export default "__VITE_ASSET__C2kbuN9h__"